import { Sidebar } from './Sidebar';
import { SidebarSection } from './SidebarSection';
import { SidebarClose } from './SidebarClose';
import { SidebarMobileFluid } from './SidebarMobileFluid';

Sidebar.Section = SidebarSection;
Sidebar.Close = SidebarClose;
Sidebar.MobileFluid = SidebarMobileFluid;

export default Sidebar;